import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { FINANCIAL_API } from "./apiRoutes";

interface UseGetFinancialReportingProps {
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getFinancialReporting = async () =>
  await axiosAuth.get(`${FINANCIAL_API}/`);

const useGetFinancialReporting = ({
  queryParams,
}: UseGetFinancialReportingProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["financial-reporting"],
    queryFn: () => getFinancialReporting(),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetFinancialReporting;
